<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :ok-disabled="disableSubmit"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    cancelText="关闭">
    <empzone-col-content-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></empzone-col-content-form>
  </j-modal>
</template>

<script>

  import EmpzoneColContentForm from './EmpzoneColContentForm'
  export default {
    name: 'EmpzoneColContentModal',
    components: {
      EmpzoneColContentForm
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      /*add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },*/
      addData(colId,colCode,colName){
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add(colId,colCode,colName);
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>